import type { AnimationMeta } from './schema';

/**
 * Pure spritesheet geometry helpers shared by the image-backed and placeholder
 * spritesheets. A sheet is a row-major grid of equal `frameWidth × frameHeight`
 * cells; a frame index addresses one cell. Kept separate from the canvas code so
 * the math is unit-testable without a browser.
 */

/** Highest sheet frame index referenced by any state (⇒ minimum frame count − 1). */
export function maxFrameIndex(meta: AnimationMeta): number {
  let max = 0;
  for (const state of Object.values(meta.states)) {
    for (const f of state.frames) if (f > max) max = f;
  }
  return max;
}

/** Number of whole frames across the sheet width (at least 1). */
export function frameColumns(imageWidth: number, frameWidth: number): number {
  return Math.max(1, Math.floor(imageWidth / frameWidth));
}

export interface SrcRect {
  sx: number;
  sy: number;
  sw: number;
  sh: number;
}

/** Source rect for a frame index in a row-major grid of `columns` columns. */
export function frameSrcRect(frameIndex: number, frameWidth: number, frameHeight: number, columns: number): SrcRect {
  const col = frameIndex % columns;
  const rowIdx = Math.floor(frameIndex / columns);
  return { sx: col * frameWidth, sy: rowIdx * frameHeight, sw: frameWidth, sh: frameHeight };
}
